import * as yup from 'yup';
import {
	firstNameSchema,
	lastNameSchema,
	emailIdSchema,
	confirmEmailIdSchema,
	passwordSchema,
	phoneNumberSchema,
	confirmPasswordSchema,
	companyNameSchema,
} from 'validations/common';

export const userProfileValidationSchema = yup.object().shape({
	firstName: firstNameSchema.nullable(),
	lastName: lastNameSchema.nullable(),
	phoneNumber: phoneNumberSchema.nullable(),
	emailId: emailIdSchema.nullable(),
	confirmEmailId:confirmEmailIdSchema.nullable(),
	state: yup
		.string()
		.required('Status is a mandatory field')
		.min(1, 'Select State')
		.nullable(),
	city: yup
		.string()
		.required('Status is a mandatory field')
		.min(1, 'Select City')
		.nullable(),

	companyName: companyNameSchema,
	// businessCategory:yup.string().required('Bussiness category is a mandatory field'),
});

export const userCredentialsValidateSchema = yup.object().shape({
	currentPassword: yup.string().required('Password is a mandatory field'),
	password: passwordSchema,
	confirmPassword: confirmPasswordSchema,
});
